import axios from "axios";
import { Button, Dialog, Pane, Text } from "evergreen-ui";
import React, { useEffect, useState } from "react";
import { mua } from "../MUA";

function ComponentPay({ data }) {
  const [isOpen, setisOpen] = useState(false);
  const [DataPay, setDataPay] = useState([]);
  const [Clas, setClas] = useState("");
  useEffect(() => {
    if (data[0].REGISTER_STATUS === "4" || data[0].REGISTER_STATUS === "6") {
      if (
        data[0].REGISTER_STATUS_BILL_ROBFULL_BOOK !== null ||
        data[0].REGISTER_STATUS_BILL_ROB2_BOOK !== null
      ) {
        setClas("d-none");
      } else {
        setClas("d-block");
      }
    } else if (
      data[0].REGISTER_STATUS === "9" &&
      (data[0].ROB_ID === "167" || data[0].ROB_ID === "160")
    ) {
      setClas("d-block");
    } else {
      setClas("d-none");
    }
  }, []);
  const SetDetailPayDoc = async () => {
    try {
      const fetch = await axios.get(
        mua +
        "/admission/getEligibleInterviewReports_new/" +
        data[0].CITIZENT_LOGIN +
        "/" +
        data[0].REGISTER_STATUS +
        "/" +
        data[0].ROB_ID +
        "/" +
        data[0].REGISTER_ID
      );
      const datas = await fetch.data;
      setDataPay(datas);
      setisOpen(true);
      console.log(datas);
    } catch (error) { }
  };
  const CheckOpenButtonPay = () => {
    const DATESTART = new Date(data[0].QUOTA_DATE_OPEN_MONEY + " 00:00");
    const DATESTOP = new Date(data[0].QUOTA_DATE_CLOSE_MONEY + " 23:59");
    const DATENOW = new Date();
    if (DATESTART <= DATENOW && DATENOW <= DATESTOP) {
      console.log("DATE START ผ่านไปแล้ว");
      console.log(DATESTART);
      console.log(DATESTOP);
      console.log(DATENOW);
      return false;
    } else if (DATENOW > DATESTOP) {
      console.log(DATESTART);
      console.log(DATENOW);
      console.log("วันปัจจุบันมากกว่าวันสิ้นสุด");
      return true;
    } else {
      return true;
    }
    // return false;
  };

  return (
    <>
      {data[0].REGISTER_STATUS_BILL_ROB1_BOOK !== null ? (
        
          data[0].Major1_MAJOR_ID === "9902" ? (
            <Button
              className={Clas}
              // disabled={CheckOpenButtonPay()}
              // disabled
              onClick={() => {
                SetDetailPayDoc();
              }}
              appearance="primary"
              intent="success"
            >
              {data[0].REGISTER_STATUS === "4"
                ? "ชำระเงินและยืนยันสิทธิ์"
                : "ชำระเงินค่าธรรมเนียมการศึกษางวดที่ 2"}
            </Button>
          ) : (
            <Button
              className={Clas}
              // disabled={CheckOpenButtonPay()}
              // disabled
              onClick={() => {
                SetDetailPayDoc();
              }}
              appearance="primary"
              intent="success"
            >
              {data[0].REGISTER_STATUS === "4"
                ? "ชำระเงินและยืนยันสิทธิ์"
                : "ชำระเงินค่าธรรมเนียมการศึกษางวดที่ 2"}
            </Button>
          )
        
      ) : (<Button
        className={Clas}
        // disabled={CheckOpenButtonPay()}
        // disabled
        onClick={() => {
          SetDetailPayDoc();
        }}
        appearance="primary"
        intent="success"
      >
        {data[0].REGISTER_STATUS === "4"
          ? "ชำระเงินและยืนยันสิทธิ์"
          : ""}
      </Button>)}

      <Dialog
        hasFooter={false}
        isShown={isOpen}
        onCloseComplete={() => {
          setisOpen(false);
        }}
      >
        <Pane
          backgroundColor="#f2ebfb20"
          color="#9667e0"
          padding={10}
          fontWeight={500}
          borderRadius={8}
          borderColor="#9667e0"
          border="solid"
          borderWidth="1px"
          fontFamily=""
        >
          ท่านสามารถพิมพ์ใบแจ้งการชำระเงินเพื่อชำระค่าธรรมเนียมการศึกษาผ่านช่องทางเคาน์เตอร์เซอร์วิส
          หรือช่องทางธนาคาร หรือชำระเงินค่าธรรมเนียมการศึกษาออนไลน์ได้
        </Pane>
        <Pane
          paddingTop={10}
          display="flex"
          flexDirection="column"
          gap={5}
          hidden={data[0].Major1_MAJOR_ID === "9901"}
        >
          <Text>สามารถเลือกช่องทางการชำระเงินได้ดังนี้</Text>
          <Text>ช่องทาง Counter service</Text>
          <Button
            hidden={
              data[0].Major1_LEVEL_OPEN_NAME === "ครุศาสตรบัณฑิต" ||
                data[0].Major1_MAJOR_ID === "1110" ||
                data[0].Major1_MAJOR_ID === "1110" ||
                data[0].Major1_MAJOR_ID === "1106" ||
                data[0].Major1_MAJOR_ID === "8301"||
                data[0].Major1_MAJOR_ID === "8203"||
                data[0].Major1_MAJOR_ID === "8201"||
                data[0].Major1_MAJOR_ID === "8205"||
                data[0].Major1_MAJOR_ID === "8401"||
                data[0].Major1_MAJOR_ID === "9902"
                ? true
                : (data[0].QUOTA_ID === "3" || data[0].QUOTA_ID === "6")
                  ? true
                  : false
            }
            // hidden
            onClick={() => {
              if (data[0].REGISTER_STATUS === "4") {
                window.open(
                  "https://admission.kpru.ac.th/admission2017/student_printbill?code_test=" +
                  DataPay[0].REGISTER_ID +
                  "&typebill=1&ad=1"
                );
              } else {
                window.open(
                  "https://admission.kpru.ac.th/admission2017/student_printbill?code_test=" +
                  DataPay[0].REGISTER_ID +
                  "&typebill=2&ad=1"
                );
              }
            }}
            className="btn btn-success btn-md text-white m-0"
          >
            {data[0].REGISTER_STATUS === "4"
              ? " พิมพ์ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษา (แบ่งจ่ายงวดที่ 1)"
              : " พิมพ์ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษา (แบ่งจ่ายงวดที่ 2)"}
          </Button>
          <Button
            hidden={data[0].REGISTER_STATUS !== "4"}
            onClick={() => {
              if (data[0].Major1_MAJOR_ID === "9903") {
                window.open(
                  // "https://git.kpru.ac.th/admission2017/student_printbill?code_test=" +
                  "https://admission.kpru.ac.th/admission2017/student_printbill?code_test=" +
                  DataPay[0].REGISTER_ID +
                  "&typebill=4&ad=1"
                );
              } else {
                window.open(
                  // "https://git.kpru.ac.th/admission2017/student_printbill?code_test=" +
                  "https://admission.kpru.ac.th/admission2017/student_printbill?code_test=" +
                  DataPay[0].REGISTER_ID +
                  "&typebill=3&ad=1"
                );
              }
            }}
            className="btn btn-secondary btn-md text-white m-0"
          >
            พิมพ์ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษา (แบบเต็มจำนวน)
          </Button>
          <Text>ช่องทางออนไลน์</Text>
          <Button
            hidden={
              data[0].Major1_LEVEL_OPEN_NAME === "ครุศาสตรบัณฑิต" ||
                data[0].Major1_MAJOR_ID === "1110" ||
                data[0].Major1_MAJOR_ID === "1106"||
                data[0].Major1_MAJOR_ID === "8301"||
                data[0].Major1_MAJOR_ID === "8203"||
                data[0].Major1_MAJOR_ID === "8201"||
                data[0].Major1_MAJOR_ID === "8205"||
                data[0].Major1_MAJOR_ID === "8401"||
                data[0].Major1_MAJOR_ID === "9902"
                ? true
                : (data[0].QUOTA_ID === "3" || data[0].QUOTA_ID === "6")
                  ? true
                  : false
            }
            // hidden
            onClick={() => {
              if (data[0].REGISTER_STATUS === "4") {
                window.open(
                  "https://e-payment.kpru.ac.th/pay/typepayment?comp=80427&orderRef1=" +
                  DataPay[0].REGISTER_ID +
                  "&amount=" +
                  DataPay[0].SALARY_MONEY_1 +
                  "&endDate=" +
                  DataPay[0].SALARY_DATE_CLOSE +
                  "&urlredirect=https://admission.kpru.ac.th/admission/Dataregister&term=1/2569&name=" +
                  DataPay[0].FULLNAME +
                  DataPay[0].FRISTNAME_LOGIN +
                  "&lname=" +
                  DataPay[0].LASTNAME_LOGIN
                );
              } else {
                window.open(
                  "https://e-payment.kpru.ac.th/pay/typepayment?comp=80427&orderRef1=" +
                  DataPay[0].REGISTER_ID +
                  "&amount=" +
                  DataPay[0].SALARY_MONEY_2 +
                  "&endDate=" +
                  DataPay[0].SALARY_DATE_CLOSE +
                  "&urlredirect=https://admission.kpru.ac.th/admission/Dataregister&term=1/2569&name=" +
                  DataPay[0].FULLNAME +
                  DataPay[0].FRISTNAME_LOGIN +
                  "&lname=" +
                  DataPay[0].LASTNAME_LOGIN
                );
              }
            }}
            className="btn btn-info btn-md text-white m-0"
          >
            {data[0].REGISTER_STATUS === "4"
              ? " ชำระเงินค่าธรรมเนียมการศึกษาออนไลน์(แบ่งจ่ายงวดที่ 1)"
              : "ชำระเงินค่าธรรมเนียมการศึกษาออนไลน์(แบ่งจ่ายงวดที่ 2)"}
          </Button>
          <Button
            hidden={data[0].REGISTER_STATUS !== "4"}
            onClick={() => {
              window.open(
                "https://e-payment.kpru.ac.th/pay/typepayment?comp=80427&orderRef1=" +
                DataPay[0].REGISTER_ID +
                "&amount=" +
                DataPay[0].SALARY_MONEY_FULL +
                "&endDate=" +
                DataPay[0].SALARY_DATE_CLOSE +
                "&urlredirect=https://admission.kpru.ac.th/admission/Dataregister&term=1/2569&name=" +
                DataPay[0].FULLNAME +
                DataPay[0].FRISTNAME_LOGIN +
                "&lname=" +
                DataPay[0].LASTNAME_LOGIN
              );
            }}
            className="btn btn-danger m-0 btn-md text-white"
          >
            ชำระเงินค่าธรรมเนียมการศึกษาออนไลน์(เต็มจำนวน)
          </Button>
        </Pane>
        <Pane
          paddingTop={10}
          display="flex"
          flexDirection="column"
          gap={5}
          hidden={data[0].Major1_MAJOR_ID !== "9901"}
        >
          <Text>สามารถเลือกช่องทางการชำระเงินได้ดังนี้</Text>
          <Text>ช่องทาง Counter service</Text>
          <Button
            // hidden
            onClick={() => {
              if (data[0].REGISTER_STATUS === "4") {
                window.open(
                  "https://admission.kpru.ac.th/admission2017/student_printbill?code_test=" +
                  DataPay[0].REGISTER_ID +
                  "&typebill=1&ad=1"
                );
              } else {
                window.open(
                  "https://admission.kpru.ac.th/admission2017/student_printbill?code_test=" +
                  DataPay[0].REGISTER_ID +
                  "&typebill=2&ad=1"
                );
              }
            }}
            className="btn btn-success btn-md text-white m-0"
          >
            {data[0].REGISTER_STATUS === "4"
              ? " พิมพ์ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษา (แบ่งจ่ายงวดที่ 1)"
              : " พิมพ์ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษา (แบ่งจ่ายงวดที่ 2)"}
          </Button>
          <Button
            hidden={data[0].REGISTER_STATUS !== "4"}
            onClick={() => {
              if (data[0].Major1_MAJOR_ID === "9901") {
                window.open(
                  // "https://git.kpru.ac.th/admission2017/student_printbill?code_test=" +
                  "https://admission.kpru.ac.th/admission2017/student_printbill?code_test=" +
                  DataPay[0].REGISTER_ID +
                  "&typebill=4&ad=1"
                );
              } else {
                window.open(
                  // "https://git.kpru.ac.th/admission2017/student_printbill?code_test=" +
                  "https://admission.kpru.ac.th/admission2017/student_printbill?code_test=" +
                  DataPay[0].REGISTER_ID +
                  "&typebill=3&ad=1"
                );
              }
            }}
            className="btn btn-secondary btn-md text-white m-0"
          >
            พิมพ์ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษา (แบบเต็มจำนวน)
          </Button>
          <Text>ช่องทางออนไลน์</Text>
          <Button
            // hidden
            onClick={() => {
              if (data[0].REGISTER_STATUS === "4") {
                window.open(
                  "https://e-payment.kpru.ac.th/pay/typepayment?comp=80427&orderRef1=" +
                  DataPay[0].REGISTER_ID +
                  "&amount=" +
                  DataPay[0].SALARY_MONEY_1 +
                  "&endDate=" +
                  DataPay[0].SALARY_DATE_CLOSE +
                  "&urlredirect=https://admission.kpru.ac.th/admission/Dataregister&term=1/2569&name=" +
                  DataPay[0].FULLNAME +
                  DataPay[0].FRISTNAME_LOGIN +
                  "&lname=" +
                  DataPay[0].LASTNAME_LOGIN
                );
              } else {
                window.open(
                  "https://e-payment.kpru.ac.th/pay/typepayment?comp=80427&orderRef1=" +
                  DataPay[0].REGISTER_ID +
                  "&amount=" +
                  DataPay[0].SALARY_MONEY_2 +
                  "&endDate=" +
                  DataPay[0].SALARY_DATE_CLOSE +
                  "&urlredirect=https://admission.kpru.ac.th/admission/Dataregister&term=1/2569&name=" +
                  DataPay[0].FULLNAME +
                  DataPay[0].FRISTNAME_LOGIN +
                  "&lname=" +
                  DataPay[0].LASTNAME_LOGIN
                );
              }
            }}
            className="btn btn-info btn-md text-white m-0"
          >
            {data[0].REGISTER_STATUS === "4"
              ? " ชำระเงินค่าธรรมเนียมการศึกษาออนไลน์(แบ่งจ่ายงวดที่ 1)"
              : "ชำระเงินค่าธรรมเนียมการศึกษาออนไลน์(แบ่งจ่ายงวดที่ 2)"}
          </Button>
          <Button
            hidden={data[0].REGISTER_STATUS !== "4"}
            onClick={() => {
              window.open(
                "https://e-payment.kpru.ac.th/pay/typepayment?comp=80427&orderRef1=" +
                DataPay[0].REGISTER_ID +
                "&amount=" +
                DataPay[0].SALARY_MONEY_FULL +
                "&endDate=" +
                DataPay[0].SALARY_DATE_CLOSE +
                "&urlredirect=https://admission.kpru.ac.th/admission/Dataregister&term=1/2569&name=" +
                DataPay[0].FULLNAME +
                DataPay[0].FRISTNAME_LOGIN +
                "&lname=" +
                DataPay[0].LASTNAME_LOGIN
              );
            }}
            className="btn btn-danger m-0 btn-md text-white"
          >
            ชำระเงินค่าธรรมเนียมการศึกษาออนไลน์(เต็มจำนวน)
          </Button>
        </Pane>
      </Dialog>

    </>
  );
}

export default ComponentPay;
